import { ComponentType } from "react";
import { Control, FieldValues, useController, UseControllerProps } from "react-hook-form";

export function withController<T extends Record<string, unknown>>(Component: ComponentType<T>) {
  return function ControlledComponent<U extends FieldValues>({
    name,
    control,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
    ...props
  }: T & Omit<UseControllerProps<U>, "control"> & { control: Control<U> }) {
    const {
      field: { disabled: disabledState, name: nameState, ...controllerRest },
      fieldState: { error: fieldError }
    } = useController({ name, control, defaultValue, disabled, rules, shouldUnregister });

    return <Component disabled={disabledState} name={nameState} error={fieldError?.message} {...controllerRest} {...(props as unknown as T)} />;
  };
}
